import { LoginData, RoleType } from '../models/authentication.models';

export const cookies: Readonly<LoginData> = {
	user_id: '',
	avatar: '',
	token: '',
	role: '' as RoleType,
};
